export default __webpack_public_path__ + "static/media/heroku-background.ea234afc.svg";